import React, { useState, useEffect } from "react";
import { Table, Button, Row, Col, Card, Form } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import { deleteRole, getRoles } from "../../../../services/RoleService";
import {
  DatatableWrapper,
  TableBody,
  TableHeader,
  PaginationOptions,
  Pagination,
} from "react-bs-datatable";

const RoleList = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filterText, setFilterText] = useState("");

  useEffect(() => {
    fetchRoles();
  }, []);

  const fetchRoles = async () => {
    try {
      const data = await getRoles();
      setRoles(data);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteRole(id);
      fetchRoles(); // Refresh list after deletion
      console.log("Roles deleted successfully");
    } catch (error) {
      console.error("Error deleting role:", error);
    }
  };

  // Table headers for the datatable
  const header = [
    { prop: "label", title: "Label" },
    { prop: "slug", title: "Slug" },
    { prop: "createdAt", title: "Created At" },
    { prop: "updatedAt", title: "Updated At" },
    {
      prop: "actions",
      title: "Actions",
      cell: (row) => (
        <>
          <Link
            to={"/settings/roles/edit/" + row._id}
            variant="primary"
            className="btn btn-primary shadow btn-xs sharp me-1"
          >
            <i className="fa fa-pencil"></i>
          </Link>
          <Button
            variant="danger"
            className="btn btn-danger shadow btn-xs sharp me-1"
            onClick={() => handleDelete(row._id)}
          >
            <i className="fa fa-trash"></i>
          </Button>
        </>
      ),
    },
  ];

  // Format data for the table
  const tableData = roles.map((role) => ({
    label: role.label,
    slug: role.slug,
    createdAt: moment(role.createdAt).format("YYYY-MM-DD"),
    updatedAt: moment(role.updatedAt).format("YYYY-MM-DD"),
    _id: role._id, // Include for delete/edit actions
  }));

  // Filter the data based on the role label
  const filteredData = tableData.filter(
    (item) => item.label && item.label.toLowerCase().includes(filterText.toLowerCase())
  );

  return (
    <Card>
      <div className="card-body">
        <Row>
          <Col xs={12}>
            <h4>Role List</h4>
            <Link
              variant="primary"
              to={"/settings/roles/add"}
              className="mb-4 d-flex justify-content-end"
            >
              <Button>Add Role</Button>
            </Link>

            <DatatableWrapper
              body={filteredData} // Use filtered data for the table
              headers={header}
              paginationOptionsProps={{
                initialState: {
                  rowsPerPage: 5, // Set rows per page
                  options: [5, 10, 15], // Options for rows per page
                },
              }}
            >
              <Row className="mb-4">
                <Col
                  xs={12}
                  lg={4}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Form.Control
                    type="text"
                    placeholder="Search by Role Label"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table>
                <TableHeader />
                <TableBody />
              </Table>

              <Row>
                <Col className="d-flex flex-col justify-content-start">
                  <PaginationOptions />
                </Col>
                <Col className="mt-4 d-flex  justify-content-end align-items-end">
                  <Pagination />
                </Col>
              </Row>
            </DatatableWrapper>
          </Col>
        </Row>
      </div>
    </Card>
  );
};

export default RoleList;
